import React, { useState, useContext, useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import {
  getUserInfo,
  getApiTargetInfo,
  getEnvConfig,
  getUserName,
} from 'core/selectors'
import { saveUserInfo, doPasswordReset } from 'api/pgads'
import { Title, Content, FullHeightSizer } from 'core/screen-util'
import { Input, Button, message, Icon, Switch, Divider } from 'antd'
import { ErrorContext } from 'context'
import { STORE_USERINFO } from 'core/action-names'
import { ClientContext } from 'context/ClientContext'
import {
  setDarkmodeInCookie,
  setFontColorInCookie,
  setZoomInCookie,
} from './../../UserCookieSetting'

import styled from '@emotion/styled'
import { getIsPasswordDisabled } from 'utils'
const Label = styled.div`
  display: grid;
  justify-content: end;
  align-content: center;
`
export const textcolor1 = 'textcolor-1'
export const fontColorList = [textcolor1, 'defult']

const UserInfo = ({
  userInfo,
  saveUserInfoInStore,
  targetInfo,
  envConfig,
  userName,
}) => {
  const { pageZoom, setPageZoom, setFontColor } = useContext(ClientContext)

  const { setError } = useContext(ErrorContext)
  const [userUpdate, setUserUpdate] = useState(userInfo)
  const defPassSetup = {
    userName: userInfo.userName,
    existingPassword: '',
    newPassword: '',
  }
  const [passwordUpdate, setPasswordUpdate] = useState(defPassSetup)
  const [passwordEditable, setPasswordEditable] = useState(false)
  const [editable, setEditable] = useState(false)
  useEffect(() => {
    setUserUpdate(userInfo)
  }, [userInfo])

  const saveUserData = () => {
    saveUserInfo(targetInfo)(userUpdate).fork(setError, () => {
      message.info('User Information saved')
      saveUserInfoInStore(userUpdate)
      setEditable(false)
    })
  }

  const { theme, setTheme } = useContext(ClientContext)

  const savePassword = _ => {
    const { existingPassword, newPassword, conformPassword } = passwordUpdate
    if (newPassword === existingPassword) {
      message.error('New Password should not the same as Current Password')
      return
    }
    if (newPassword !== conformPassword) {
      message.error('New Password and Confirm Password is not same')
      return
    }
    if ((newPassword || '').length !== (newPassword || '').trim().length) {
      message.error('Password should not start or end with " "(space)')
      return
    }

    if ((newPassword || '').includes(' ')) {
      message.error('Password should include" "(space)')
      return
    }
    if ((newPassword || '').length < 7) {
      message.error('Password should have minimum 7 length charactor')
      return
    }
    if ((existingPassword || '').trim().length === 0) {
      message.error('Password should have minimum 7 length charactor')
      return
    }

    doPasswordReset(targetInfo)(passwordUpdate).fork(setError, _ => {
      setPasswordUpdate({ userName: userInfo.userName })
      setPasswordEditable(false)
    })
  }

  // useEffect(
  //   _ => {
  //     setZoomInCookie(userName, pageZoom)
  //   },
  //   [pageZoom, userName]
  // )
  const plusZoom = _ => {
    setZoomInCookie(userName, pageZoom + 1)
    setPageZoom(pageZoom + 1)
  }
  const minusZoom = _ => {
    setPageZoom(pageZoom - 1)
    setZoomInCookie(userName, pageZoom - 1)
  }

  const setThemeValue = val => {
    setDarkmodeInCookie(userName, val)
    setTheme(val)
  }

  const passwordDisabled = useMemo(_ => getIsPasswordDisabled(envConfig), [
    envConfig,
  ])

  return (
    <FullHeightSizer heightOffset={200}>
      {() => (
        <Content
          style={{
            height: 'calc(100vh - 171px)',
            display: 'grid',
            gridTemplateColumns: '1fr 20px 1fr',
            gridColumnGap: '30px',
          }}
        >
          <div>
            <Title style={{ display: 'grid', justifyContent: 'center' }}>
              <span>
                <Icon type="user" />
                <span style={{ marginLeft: '15px' }}>User Information</span>
              </span>
            </Title>
            <div
              style={{
                display: 'grid',
                gridGap: '15px',
                gridTemplateColumns: '150px 450px',
                marginTop: '20px',
                justifyContent: 'center',
              }}
            >
              <Label>User Name : </Label>
              <Input
                disabled
                value={userUpdate.userName}
                onChange={e =>
                  setUserUpdate({ ...userUpdate, userName: e.target.value })
                }
              />
              <Label>First Name : </Label>
              <Input
                value={userUpdate.firstName}
                onChange={e =>
                  setUserUpdate({ ...userUpdate, firstName: e.target.value })
                }
                disabled={!editable}
              />
              <Label>Last Name : </Label>
              <Input
                value={userUpdate.lastName}
                onChange={e =>
                  setUserUpdate({ ...userUpdate, lastName: e.target.value })
                }
                disabled={!editable}
              />
              <Label>Email : </Label>
              <Input
                value={userUpdate.email}
                onChange={e =>
                  setUserUpdate({ ...userUpdate, email: e.target.value })
                }
                disabled={!editable}
              />
              <Label>Phone Number : </Label>
              <Input
                value={userUpdate.phone}
                onChange={e =>
                  setUserUpdate({ ...userUpdate, phone: e.target.value })
                }
                disabled={!editable}
              />

              <div />
              {!editable && (
                <Button type="dashed" onClick={() => setEditable(true)}>
                  Edit Data
                </Button>
              )}

              {editable && (
                <div
                  style={{ display: 'flex', justifyContent: 'space-around' }}
                >
                  <Button
                    onClick={saveUserData}
                    type="danger"
                    style={{ width: '150px' }}
                  >
                    Save
                  </Button>
                  <Button
                    type="dashed"
                    onClick={() => {
                      setUserUpdate(userInfo)
                      setEditable(false)
                    }}
                    style={{ width: '150px' }}
                  >
                    Cancel
                  </Button>
                </div>
              )}
              {!passwordDisabled && (
                <React.Fragment>
                  <Label>Old Password : </Label>
                  <Input.Password
                    type="password"
                    value={passwordUpdate.existingPassword || ''}
                    onChange={e =>
                      setPasswordUpdate({
                        ...passwordUpdate,
                        existingPassword: e.target.value,
                      })
                    }
                    disabled={!passwordEditable}
                  />
                  <Label>New Password : </Label>
                  <Input.Password
                    type="password"
                    value={passwordUpdate.newPassword || ''}
                    onChange={e =>
                      setPasswordUpdate({
                        ...passwordUpdate,
                        newPassword: e.target.value,
                      })
                    }
                    placeholder="New Password"
                    disabled={!passwordEditable}
                  />
                  <Label>Confirm Password : </Label>
                  <Input.Password
                    type="password"
                    value={passwordUpdate.conformPassword || ''}
                    onChange={e =>
                      setPasswordUpdate({
                        ...passwordUpdate,
                        conformPassword: e.target.value,
                      })
                    }
                    placeholder="Confirm New Password"
                    disabled={!passwordEditable}
                  />
                  <div />
                  {!passwordEditable && (
                    <Button
                      type="dashed"
                      onClick={() => setPasswordEditable(true)}
                    >
                      Change Password
                    </Button>
                  )}
                  {passwordEditable && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-around',
                      }}
                    >
                      <Button
                        onClick={savePassword}
                        type="danger"
                        style={{ width: '150px' }}
                      >
                        Save Password
                      </Button>
                      <Button
                        type="dashed"
                        onClick={() => {
                          // setUserUpdate(userInfo)
                          setPasswordUpdate({ userName: userInfo.userName })
                          setPasswordEditable(false)
                        }}
                        style={{ width: '150px' }}
                      >
                        Cancel
                      </Button>
                    </div>
                  )}
                </React.Fragment>
              )}
            </div>
          </div>
          <div>
            <Divider type="vertical" style={{ height: '100%' }} />
          </div>
          <div>
            <Title style={{ display: 'grid', justifyContent: 'center' }}>
              <span>
                <Icon type="smile" theme="twoTone" />
                <span style={{ marginLeft: '15px' }}>User Preference</span>
              </span>
            </Title>
            <div
              style={{
                display: 'grid',
                gridGap: '15px',
                gridTemplateColumns: '110px 450px',
                marginTop: '20px',
                justifyContent: 'center',
              }}
            >
              <Label>Dark Mode :</Label>
              <Switch
                checked={theme}
                onChange={setThemeValue}
                // size="small"
                checkedChildren="ON"
                unCheckedChildren="OFF"
                style={{ maxWidth: '50px' }}
              />

              <Label>ZOOM :</Label>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Button onClick={plusZoom} type="primary">
                  <Icon type="plus-circle" theme="twoTone" />
                </Button>
                <div style={{ padding: '0 1rem' }}>{pageZoom}</div>
                <Button onClick={minusZoom} type="primary">
                  <Icon type="minus-circle" theme="twoTone" />
                </Button>
              </div>

              <div
                style={{
                  display: 'grid',
                  alignContent: 'start',
                  justifyContent: 'end',
                }}
              >
                Font Color :
              </div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
                  gap: '2px',
                  height: '100px',
                }}
              >
                {/* <div>{fontColor}</div> */}
                {fontColorList.map(c => (
                  <div
                    style={{
                      backgroundColor:
                        c === 'defult' ? 'rgba(0, 0, 0, 0.6)' : `var(--${c})`,
                      height: '20px',
                      border: '1px solid black',
                    }}
                    key={c}
                    onClick={_ => {
                      document.body.classList.remove(...fontColorList)
                      setFontColorInCookie(userName, c)
                      setFontColor(c)
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </Content>
      )}
    </FullHeightSizer>
  )
}

const mapStateToProps = state => ({
  userInfo: getUserInfo(state),
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  userName: getUserName(state),
})
const mapDispatchToProps = dispatch => ({
  saveUserInfoInStore: userData =>
    dispatch({ type: STORE_USERINFO, payload: userData }),
})

export default connect(mapStateToProps, mapDispatchToProps)(UserInfo)
